import { Typography } from "@mui/material";

export const LabelValue = ({
  label,
  value,
}: {
  label: string;
  value?: string | null;
}) => (
  <>
    <Typography sx={{ color: "text.secondary" }} variant="body2">
      {label}
    </Typography>
    <Typography>{value}</Typography>
  </>
);
